import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/butter-theme.css";
import App from "@/App";
import { bootstrapTheme } from "@/context/ThemeContext";
import { bootstrapBrandTheme } from "@/lib/counterCultureTheme";
import "@/styles/counterCulture.css";
import "@/styles/counterCultureLegacy.css";

// Apply theme BEFORE first paint — prevents a flash of the wrong theme
// on refresh when the user has chosen a non-system preference.
bootstrapTheme();
bootstrapBrandTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
